import { useContext } from 'react';
import { IMutedParticipantsContext, MutedParticipantsContext } from 'context';

export function useMutedParticipants(): IMutedParticipantsContext {
  return useContext(MutedParticipantsContext)!;
}
